<!-- 人工校准 -->
<template>
  <!-- 移动端 -->
  <drawer-mobile
    v-if="isMobile()"
    v-model:show-detail="showDetail"
    :title="title"
    @commit="submitForm"
  >
    <Core ref="coreRef" :risk-info="riskInfo" />
    <template #footer>
      <el-button @click="showDetail = false">取消</el-button>
      <el-button type="primary" @click="submitForm"> 确定校准 </el-button>
    </template>
  </drawer-mobile>
  <!-- PC端 -->
  <el-dialog
    v-else
    v-model="showDetail"
    align-center
    append-to-body
    body-class="ai-calibration-dialog__body"
    class="ai-calibration-dialog"
    footer-class="ai-calibration-dialog__footer"
    header-class="ai-calibration-dialog__header"
    :title="title"
  >
    <Core ref="coreRef" :risk-info="riskInfo" />
    <template #footer>
      <el-button @click="showDetail = false">取消</el-button>
      <el-button type="primary" @click="submitForm"> 确定校准 </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { isMobile } from '@/utils'
import { saveManualVerificationInfo } from '@/api/ai-board'
import DrawerMobile from '@/components/drawer-mobile/index.vue'
import Core from './components/core/index.vue'

const emits = defineEmits(['update:showDetail', 'handleRefresh'])
const props = defineProps({
  showDetail: {
    type: Boolean,
    default: false
  },
  // 拜访轨迹详情ID
  behavingId: {
    type: Number,
    default: 1
  },
  // 初始分析信息
  riskInfo: {
    type: Object,
    default: () => ({
      riskResult: '',
      riskStatus: 0
    })
  }
})

const showDetail = computed({
  get() {
    return props.showDetail
  },
  set(val) {
    emits('update:showDetail', val)
  }
})

const title = '质量分析人工校准'
const coreRef = ref()

/**
 * 保存人工校验结果
 */
const save = async () => {
  const formData = coreRef.value.formData

  try {
    await saveManualVerificationInfo({
      behavingId: props.behavingId,
      staffRiskStatus: formData.staffRiskStatus,
      staffRiskResult: formData.staffRiskResult.slice(0, 2000)
    })
    showDetail.value = false
    emits('handleRefresh')
  } catch (error) {
    console.error('保存人工校验结果失败', error)
  }
}

/**
 * 提交表单
 */
const submitForm = async () => {
  const _formRef = coreRef.value.formRef

  if (!_formRef) return
  await _formRef.validate((valid, fields) => {
    if (valid) {
      save()
    }
  })
}

onMounted(() => {})
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.ai-calibration-dialog {
  padding: 24px 24px 20px !important;
  border-radius: 12px;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);

  &__header {
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 24px;
    border-bottom: none !important;
  }

  &__body {
    padding: 0 0 20px 0 !important;
  }

  &__footer {
    height: unset !important;
    line-height: unset !important;
    padding: 0 !important;
    border-top: none !important;
  }
}
</style>
